<template>
  <v-row
    align="stretch"
    justify="start"
  >
    <v-col
      cols="12"
    >
      <base-material-card
        color="coolrunner"
        icon="mdi-tag-multiple"
        inline
        class="px-5 py-3"
        lg="4"
      >
        <template v-slot:after-heading>
          <v-col>
            <div class="text-h2 font-weight-light">
              {{ $t('balance') }}
            </div>
            <div class="text-h2 font-weight-bold">
              {{ balance ? balance.toFixed(2) + ' DKK' : '-' }}
            </div>
          </v-col>
        </template>

        <v-row>
          <v-col
            cols="8"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              style="marginBottom: 20px"
            />

            <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :items-per-page="20"
              :search="search"

              dense
              class="elevation-1"
            >
              <template v-slot:item.created_at="{item}">
                {{ convertUTCToLocal(item.created_at) }}
              </template>
            </v-data-table>
          </v-col>
          <v-col
            cols="4"
            class="ml-auto"
          >
            <v-card class="pa-2 mt-0">
              <v-form>
                <div class="text-h2 text-center">
                  {{ $t('export') + " "+ $t('balance') }}
                </div>
                <v-row>
                  <v-col>
                    <v-menu
                      ref="menu1"
                      v-model="menu1"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="exportDates.dateFrom"
                          :label="$t('from')"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="exportDates.dateFrom"
                        :max="new Date().toISOString().substr(0, 10)"
                        @change="save"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col>
                    <v-menu
                      ref="menu2"
                      v-model="menu2"
                      :close-on-content-click="true"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="exportDates.dateTo"
                          :label="$t('to')"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="exportDates.dateTo"
                        :max="new Date().toISOString().substr(0, 10)"
                        @change="save"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="updating"
                      @click="exportBalance"
                    >
                      {{ $t('export') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
            <v-card class="pa-2 mt-0">
              <v-form>
                <div class="text-h2 text-center">
                  {{ $t('balance') + " "+ $t('settings') }}
                </div>
                <v-switch
                  v-model="autofill.autofill"
                  :label="$t('autofill')"
                  dense
                />
                <v-row>
                  <v-col>
                    <v-text-field
                      v-model="autofill.autofill_threshold"
                      :disabled="!autofill.autofill"
                      type="number"
                      :label="$t('threshold')"
                    />
                  </v-col>
                  <v-col>
                    <v-text-field
                      v-model="autofill.autofill_amount"
                      :disabled="!autofill.autofill"
                      type="number"
                      :label="$t('amount')"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="updating"
                      @click="updateAutofill"
                    >
                      {{ $t('save') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
            <v-card class="pa-2 mt-0">
              <v-form>
                <div class="text-h2 text-center">
                  {{ $t('update') + " "+ $t('balance') }}
                </div>
                <v-select
                  v-model="newBalanceEntry.title"
                  :label="$t('description')"

                  dense
                  :items="descriptions"
                  hide-details
                />
                <v-textarea
                  v-model="newBalanceEntry.description"
                  :label="$t('comment')"
                />
                <v-text-field
                  v-model="newBalanceEntry.amount"
                  type="number"
                  :label="$t('amount')"
                />
                <v-row>
                  <v-col
                    cols="12"
                    class="text-right"
                  >
                    <v-btn
                      color="primary"
                      :loading="updating"
                      :disabled="!newEntryValid"
                      @click="updateBalance"
                    >
                      {{ $t('update') }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
      </base-material-card>
    </v-col>
  </v-row>
</template>
<script>
  import Auth from '../../../../mixins/Auth'
  import { convertUTCToLocal } from '@/utils/helpers'
  import localstorage from '@/plugins/localstorage'
  import { URL_PREFIX } from '@/utils/constants'
  export default {

    mixins: [Auth],
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
    },
    data () {
      return {
        search: '',
        name: 'balance',
        menu1: false,
        menu2: false,
        items: [],
        updating: false,
        showDescription: false,
        newBalanceEntry: {
          title: '',
          description: '',
          amount: 0,
        },
        exportDates: {
          dateFrom: '',
          dateTo: '',
        },
        balance: null,
        autofill: {},
        headers: [
          {
            sortable: false,
            text: this.$t('id'),
            value: 'id',
          },
          {
            sortable: false,
            text: this.$t('description'),
            value: 'text',
            width: '100%',
          },
          {
            sortable: false,
            text: this.$t('amount'),
            value: 'amount',
          },
          {
            sortable: false,
            text: this.$t('created'),
            value: 'created_at',
          },
        ],
        descriptions: [
          { text: 'Kompensation', value: 'compensation' },
          { text: 'Overførsel mellem konti', value: 'migration' },
          { text: 'Tilgodehavende', value: 'receivable' },
          { text: 'Lukning af konto', value: 'account_closed' },
          { text: 'Grundet fejl', value: 'system_error' },
          { text: 'Andet', value: 'other' },
        ],
      }
    },
    computed: {
      newEntryValid: function () {
        if (this.newBalanceEntry.title && this.newBalanceEntry.amount) {
          if (this.newBalanceEntry.title === 'other' && !this.newBalanceEntry.description) { return false }
          return true
        }
        return false
      },
      convertUTCToLocal: () => convertUTCToLocal,
      localStorage: () => localstorage,
    },
    mounted: function () {
      this.getDataFromApi()
    },
    methods: {
      getDataFromApi: function () {
        this.$get(`/customers/${this.$route.params.id}/balance`, {})
          .then(res => {
            const { balance, history, created_at, updated_at, id, customer_id, ...autofill } = res.data
            this.balance = balance
            this.autofill = autofill
            this.items = history
          })
      },
      updateBalance: function () {
        let text = this.$_.find(this.descriptions, d => d.value === this.newBalanceEntry.title).text
        this.updating = true
        if (this.newBalanceEntry.description) { text += ` - ${this.newBalanceEntry.description}` }
        const entry = { amount: this.newBalanceEntry.amount, text }

        this.$post(`/customers/${this.$route.params.id}/balance`, entry)
          .then(res => {
            this.newBalanceEntry = {
              title: '',
              description: '',
              amount: 0,
            }
            this.updating = false
            this.items = res.data
          })
          .catch(e => {
            this.updating = false
          })
      },
      updateAutofill: function () {
        this.updating = true

        this.$put(`/customers/${this.$route.params.id}/balance/autofill`, this.autofill)
          .then(res => {
            this.updating = false
          })
          .catch(e => {
            this.updating = false
          })
      },
      exportBalance: function () {
        window.open(`${URL_PREFIX}/panel/customers/${this.$route.params.id}/balance/history/csv?from=${this.exportDates.dateFrom}&to=${this.exportDates.dateTo}&access_token=${this.localStorage.get('token')}`, '_blank')
      },
      save (date) {
        this.$refs.menu1.save(date)
        this.$refs.menu2.save(date)
      },
    },
  }
</script>
